import { useEffect, useState } from "react";
import { FaPhone, FaTelegram, FaWhatsapp } from "react-icons/fa6";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { LuUser, LuUserPlus } from "react-icons/lu";
import { MdEmail, MdOutlineSupportAgent } from "react-icons/md";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./autoSlider.css";
import "./jackpot.css";
import * as actions from "./redux/LandingPageAction";

function getHourlyBaseAmount() {
  const minAmount = 1000000;
  const maxAmount = 999999999;

  // Seed based on current hour
  const now = new Date();
  const seed =
    now.getFullYear() * 10000 +
    (now.getMonth() + 1) * 100 +
    now.getDate() * 1 +
    now.getHours();

  function seededRandom(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }

  const random = seededRandom(seed);
  return Math.floor(random * (maxAmount - minAmount)) + minAmount;
}

function getJackpotAmount() {
  const baseAmount = getHourlyBaseAmount();

  // How many seconds since start of the hour
  const now = new Date();
  const secondsSinceHour = now.getMinutes() * 60 + now.getSeconds();

  const incrementPerTick = 50; // amount increased every 3 seconds
  const ticks = Math.floor(secondsSinceHour / 3);

  return baseAmount + ticks * incrementPerTick;
}

export const Hit33LandingPage = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [jackpot, setJackpot] = useState(getJackpotAmount());
  const [lightIndex, setLightIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLightIndex((prev) => (prev + 1) % 20);
    }, 150);
    return () => clearInterval(interval);
  }, []);

  const renderLights = () => {
    const lights = [];
    for (let i = 0; i < 20; i++) {
      const isActive =
        i === lightIndex ||
        i === (lightIndex + 1) % 20 ||
        i === (lightIndex + 2) % 20;
      lights.push(
        <div key={i} className={`light ${isActive ? "light-active" : ""}`} />
      );
    }
    return lights;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setJackpot(getJackpotAmount());
    }, 3000); // update every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const landingPageState = useSelector(
    ({ landingPage }) => landingPage,
    shallowEqual
  );

  useEffect(() => {
    dispatch(
      actions.getLandingPageList({
        action: "beforeloginui",
        projectid: process.env.REACT_APP_PROJECT_ID,
      })
    );
  }, []);

  return (
    <div
      className="container-fluid text-white bg-black px-0 pt-3 pb-5 overflow-x-hidden"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/landing/background.png')`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
      }}
    >
      {/* Logo and Tagline */}
      <div className="text-center mb-3">
        <img
          src={`${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/2a.png`}
          alt="Logo"
          className="img-fluid my-4"
          style={{ maxHeight: "60px" }}
          onClick={() => navigate("/login")}
        />
        <div
          className="d-flex align-items-center mt-2 bg-warning gap-1 px-2"
          style={{ paddingTop: "2px", paddingBottom: "2px" }}
        >
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{ background: "#2a2a2a", minWidth: "28px", height: "28px" }}
          >
            <HiOutlineSpeakerphone />
          </div>
          <div
            className="rounded-pill flex-fill"
            style={{ background: "#2a2a2a" }}
          >
            <marquee
              className="text-light"
              behavior="scroll"
              direction="left"
              style={{ fontSize: "14px" }}
            >
              {landingPageState.landingPageList?.anncouncement}
            </marquee>
          </div>
        </div>
      </div>

      <div className="jackpot-container mb-3">
        <div className="jackpot-main">
          {/* Top lights strip */}
          <div className="lights-strip">{renderLights()}</div>

          {/* Main content area */}
          <div className="px-3 small">
            {/* MEGA JACKPOT and Amount in same line */}
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="mega-badge small">MEGA</div>
                <div className="jackpot-text small">JACKPOT</div>
              </div>

              <div className="amount-container-inline flex-fill text-center ms-3">
                <div className="amount-glow-inline"></div>
                <div className="amount-text-inline">
                  {jackpot.toLocaleString()}
                </div>

                {/* Sparkle effects */}
                <div className="sparkle sparkle-1-inline"></div>
                <div className="sparkle sparkle-2-inline"></div>
                <div className="sparkle sparkle-3-inline"></div>
              </div>
            </div>
          </div>

          {/* Bottom lights strip */}
          <div className="lights-strip">{renderLights().reverse()}</div>

          {/* Corner decorations */}
          <div className="corner-decoration corner-tl"></div>
          <div className="corner-decoration corner-tr"></div>
          <div className="corner-decoration corner-bl"></div>
          <div className="corner-decoration corner-br"></div>
        </div>

        {/* Outer glow effect */}
        <div className="outer-glow"></div>
      </div>

      {/* Login & Register */}
      <div className="d-flex justify-content-between mb-1">
        <button
          className="btn btn-warning w-50 fw-bold rounded-0 gap-2 d-flex align-items-center justify-content-center"
          onClick={(e) => {
            navigate("/login");
          }}
        >
          <LuUser className="fs-4" />
          {intl.formatMessage({ id: "login" })}
        </button>
        <button
          className="btn btn-danger w-50 fw-bold rounded-0 gap-2 d-flex align-items-center justify-content-center"
          onClick={(e) => {
            navigate("/register");
          }}
        >
          <LuUserPlus className="fs-4" />
          {intl.formatMessage({ id: "register" })}
        </button>
      </div>

      {/* Hot Games */}
      <div>
        <h5 className="bg-warning text-black text-center p-1 fw-bold rounded-top">
          {intl.formatMessage({ id: "hotGames" })}
        </h5>
        <div className="marquee-wrapper">
          <div className="marquee-content">
            {[...Array(12)].map((_, idx) => (
              <div key={idx} className="slide">
                <img
                  src={`${process.env.PUBLIC_URL}/image/${
                    process.env.REACT_APP_IMAGE_PATH
                  }/landing/game/${(idx % 12) + 1}.webp`}
                  alt={`Game ${idx + 1}`}
                  onClick={() => navigate("/login")}
                  className="marquee-img"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-warning mb-4 mt-2 p-1 rounded-bottom"></div>
      {/* Promotions */}
      <div className="mb-4 px-2">
        <h5 className="fw-bold text-center">
          {intl.formatMessage({ id: "topPromo" })}
        </h5>
        {landingPageState.landingPageList &&
          landingPageState.landingPageList?.promotionLists.length > 0 && (
            <div className="mb-3 d-flex justify-content-center">
              <img
                src={
                  landingPageState.landingPageList?.promotionLists[0].imageurl
                }
                alt="Promo"
                className="img-fluid rounded w-100"
                onClick={() => navigate("/login")}
              />
            </div>
          )}
        <div className="row g-2">
          {landingPageState.landingPageList?.promotionLists.map(
            (promotion, idx) => {
              if (idx === 0) {
                return null;
              }

              return (
                <div className="col-6" key={idx}>
                  <img
                    src={promotion.imageurl}
                    alt="Promo"
                    className="img-fluid rounded"
                    onClick={() => navigate("/login")}
                  />
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* Help & Support */}
      <div className="bg-dark p-3 rounded mb-4">
        <h6 className="fw-bold">{intl.formatMessage({ id: "helpSupport" })}</h6>
        <ul className="list-unstyled small mt-2">
          {landingPageState.landingPageList?.contactHelps.map(
            (contactHelp, idx) => (
              <li
                key={idx}
                className="py-1 d-flex flex-wrap align-items-center gap-1"
              >
                <div className="d-flex align-items-center">
                  <div
                    className="rounded-circle bg-warning d-inline-block me-1 position-relative"
                    style={{ width: "22px", height: "22px" }}
                  >
                    {contactHelp.contactmethod
                      .toLowerCase()
                      .includes("service") ? (
                      <MdOutlineSupportAgent className="position-absolute top-50 start-50 translate-middle" />
                    ) : contactHelp.contactmethod
                        .toLowerCase()
                        .includes("telegram") ? (
                      <FaTelegram className="position-absolute top-50 start-50 translate-middle" />
                    ) : contactHelp.contactmethod
                        .toLowerCase()
                        .includes("email") ? (
                      <MdEmail className="position-absolute top-50 start-50 translate-middle" />
                    ) : contactHelp.contactmethod
                        .toLowerCase()
                        .includes("whatsapp") ? (
                      <FaWhatsapp className="position-absolute top-50 start-50 translate-middle" />
                    ) : (
                      <FaPhone className="position-absolute top-50 start-50 translate-middle" />
                    )}
                  </div>
                  {contactHelp.contactmethod}
                </div>
                :{" "}
                <a href={contactHelp.contact} className="text-warning">
                  {contactHelp.contact}
                </a>
              </li>
            )
          )}
        </ul>
      </div>

      {/* Payment Methods */}
      <div className="mb-4 px-2">
        <h6 className="fw-bold">
          {intl.formatMessage({ id: "paymentMethod" })}
        </h6>
        <div className="d-flex flex-wrap gap-2 mt-2">
          {[...Array(13)].map((_, idx) => (
            <img
              key={idx}
              src={`${process.env.PUBLIC_URL}/image/${
                process.env.REACT_APP_IMAGE_PATH
              }/landing/bankLogo/Image (${idx + 1}).png`}
              alt="Bank"
              className="img-fluid"
              style={{ height: "31px" }}
            />
          ))}
        </div>
      </div>

      {/* Browser */}
      <div className="mb-4 px-2">
        <h6 className="fw-bold">
          {intl.formatMessage({ id: "browserCooperatives" })}
        </h6>
        <div className="d-flex gap-2 mt-2">
          {[...Array(5)].map((_, idx) => (
            <img
              key={idx}
              src={`${process.env.PUBLIC_URL}/image/${
                process.env.REACT_APP_IMAGE_PATH
              }/landing/browser/${idx + 1}.webp`}
              alt={idx}
              style={{ height: "32px" }}
            />
          ))}
        </div>
      </div>

      {/* Game Provider Section */}
      <div className="mb-4 px-2">
        <h6 className="fw-bold">
          {intl.formatMessage({ id: "gameProviderPlatform" })}
        </h6>
        {landingPageState.landingPageList?.gameTypeLists.map(
          (gameType, idx) => (
            <div className="mb-3" key={idx}>
              <h6 className="text-warning">
                {gameType.gametype.toUpperCase()} GAMES
              </h6>
              <div className="row g-2">
                {gameType.companyGameLists.map((companyGame, i) => (
                  <img
                    key={i}
                    src={companyGame.imageurl}
                    alt="Game Provider"
                    className="img-fluid col-6"
                    onClick={() => navigate("/login")}
                  />
                ))}
              </div>
            </div>
          )
        )}
      </div>

      {/* Footer Licensing */}
      <div
        className="d-flex flex-column small mt-5"
        style={{ background: "#000000" }}
      >
        <div className="d-flex p-2 align-items-center text-muted">
          <div className="col-4 d-flex flex-column align-items-center justify-content-center">
            <div className="mb-3" style={{ fontSize: "11px" }}>
              {intl.formatMessage({ id: "gamingLicense" })}
            </div>
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/landing/footer/gamecert1.png`}
                style={{ height: "50px" }}
              />
              <img
                src={`${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/landing/footer/gamecert2.png`}
                style={{ height: "50px" }}
              />
            </div>
          </div>
          <div style={{ fontSize: "10px" }}>
            {intl.formatMessage(
              { id: "landingFooter1" },
              { X: process.env.REACT_APP_SHORT_NAME }
            )}
          </div>
        </div>
        <div className="border-bottom"></div>
        <div className="d-flex p-2 align-items-center text-muted">
          <div className="col-4 d-flex flex-column align-items-center justify-content-center">
            <div className="mb-3" style={{ fontSize: "11px" }}>
              {intl.formatMessage({ id: "gamingLicense" })}
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/landing/footer/pagcor.png`}
              style={{ width: "80%" }}
            />
          </div>
          <div style={{ fontSize: "10px" }}>
            {intl.formatMessage({ id: "landingFooter2" })}
          </div>
        </div>
      </div>
    </div>
  );
};
